/**
 * @file publicationAnnotate.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Apr 05, 2022 16:23
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import store from 'src/store';

import standardMessages from 'src/services/notifications/standardMessages';

import {
    enqueueMessage,
} from 'src/store/actions/global.actions';

import { stringExists } from 'src/@common/utilities';

import {
    DOCUMENT_ANNOTATE_PUBLICATION_REQUEST,
    publicationAnnotateSuccess,
    publicationAnnotateFailure,
} from 'src/store/actions/documentAnnotator/documentAnnotatorDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/documentAnnotator/publicationAnnotate';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            annotatorId: payload.annotatorId,
            docId: payload.pubId,
            docType: payload.docType,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* createRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);

        if (stringExists(resp.payload.serverMessage)) {
            yield put(enqueueMessage(
                resp.payload.serverMessage,
                standardMessages.generalInfoMessage.options)
            );
        }

        yield put(publicationAnnotateSuccess(resp.payload));

        const targetPath = '/document/annotate';
        return action.payload.navigate(targetPath);

    } catch (error) {
        yield put(publicationAnnotateFailure(error));
        handleSagaErrors(error);

    } finally {
        // wait a bit for the pdf viewer to load the data
        setTimeout(() => {
            store.dispatch(dataLoadingSet(false));
        }, 2000);
    }

}

export default function* createRequestMonitor() {
    yield takeLatest(DOCUMENT_ANNOTATE_PUBLICATION_REQUEST, createRequestSaga);
}
